<template>
  <div class="bjzc-team-item uk-flex" @click="toDetail">
    <div class="bjzc-team-item__img uk-cover-container uk-flex-none">
      <img :src="lawyer.avatarUrl" class="" alt="" uk-cover />
    </div>
    <div class="bjzc-team-item__info uk-flex-auto">
      <div class="name">{{ $getLocaleValue(lawyer, 'name') }}</div>
      <div class="title uk-text-meta">{{ $getLocaleValue(lawyer, 'title') }}</div>
      <hr />
      <div class="desc">
        {{ removeHtmlTag($getLocaleValue(lawyer, 'content')) || '-' }}
      </div>
    </div>
  </div>
</template>

<script>
import { removeHtmlTag } from '../lib/util'
export default {
  name: '',
  components: {},
  props: {
    lawyer: {
      default: () => ({
        name: '-'
      })
    }
  },
  data() {
    return {
      removeHtmlTag
    }
  },
  created() {},
  methods: {
    toDetail() {
      this.$router.push({
        name: 'TeamDetail',
        params: { id: this.lawyer.id }
      })
    }
  }
}
</script>

<style lang="scss">
.bjzc-team-item {
  background: #fff;
  border-radius: 0.5rem;
  overflow: hidden;
  border: 1px solid #dcdfe6;
  cursor: pointer;

  transition: all 0.3s;
  &:hover {
    .bjzc-team-item__info .name {
      color: $color-primary;
    }
    border-color: $color-primary;
  }

  .bjzc-team-item__img {
    width: 10rem;
    height: 10rem;
  }
  .bjzc-team-item__info {
    padding: 1.25rem 0.63rem 0 1.25rem;
    min-width: 0;
    .name {
      font-size: 1.13rem;
      font-weight: 500;
      margin-bottom: 0.25rem;
    }
    .title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .desc {
      font-size: 0.88rem;
      display: -webkit-box;
      max-height: 2.68rem;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    hr {
      margin: 0.75rem 0;
    }
  }
}
@media (max-width: ($screen-width-l - 1)) {
  .bjzc-team-item {
    .bjzc-team-item__img {
      width: 7.5rem;
      height: 7.5rem;
    }
    .bjzc-team-item__info {
      padding: 0.5rem 0.75rem;
      .name {
        font-size: 1rem;
      }
      .desc {
        line-height: 1.25;
      }
      hr {
        margin: 0.5rem 0;
      }
    }
  }
}
</style>
